import React from "react";
import { Link } from "react-router-dom";

export default function ProgramCards({ program: { title, image, link,  },caseSpecial=false  }) {
    return (
        <div className="container-card-certificate">
            {image !== 'without' && <div className="container-image" style={{padding:'20px'}}>
                <img src={image} alt="container-situation" />
            </div>}
            <div className="container-content">
                <p style={{color: "black",fontSize: "24px",margin: "0px",padding: "0px",marginBottom: "5px",textAlign: "center",}}>
                    {title}
                </p>
                {!caseSpecial ? <Link to={link}>
                    <div style={{ background: "#fe5621" }} className="button-card-certificate">
                        View Dashboard
                    </div>
                </Link> : <a target="_blank" href={link} style={{textDecoration: 'none',margin:'0px',padding:'0px'}}>
                    <div style={{ background: "#fe5621" }} className="button-card-certificate">
                        View Example
                    </div>
                </a>}
            </div>
        </div>
    );
}